import {PageLink, PageTitle} from '../../../../_handld/layout/core'
import WraperDetails from './WraperDetails'

const handlrBreadcrumbs: Array<PageLink> = [
  {
    title: 'Handyman Management',
    path: '/backoffice/handyman-management/details/:id',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DetailsPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={handlrBreadcrumbs}>Handyman details</PageTitle>
      <WraperDetails />
    </>
  )
}

export default DetailsPage
